import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPatchRequest,
  handleGlobalPostRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGlobalMetaSchema } from "@api/types/globalService.types";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IManufacturerResponseSchema,
  IManufacturerSubmitSchema,
} from "./manufacturerAPI.types";

const getAllManufacturerAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IManufacturerResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.MANUFACTURER, searchParams, signal });

const getSingleManufacturerAPI = (
  id: string
): Promise<{ data: IManufacturerResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.MANUFACTURER}/${id}`,
  });

const createManufacturerAPI = (
  data: IManufacturerSubmitSchema
): Promise<{ data: IManufacturerResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.MANUFACTURER, data });

const updateManufacturerAPI = (
  data: IManufacturerSubmitSchema
): Promise<{ data: IManufacturerResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.MANUFACTURER}/${data.id}`, data });

const deleteManufacturerAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.MANUFACTURER}/${id}` });

export {
  createManufacturerAPI,
  deleteManufacturerAPI,
  getAllManufacturerAPI,
  getSingleManufacturerAPI,
  updateManufacturerAPI,
};
